import React from 'react';
import { useParams } from 'react-router-dom';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import AttendAllowanceAddForm from 'components/organismos/AttendAllowance/AttendAllowanceAddForm/AttendAllowanceAddForm';

const AttendAllowanceFormAdd: React.FC = () => {
  const { allowanceId } = useParams();
  return (
    <SidebarTemplate
      pageTitle={allowanceId ? '手当マスタ編集' : '手当マスタ作成'}
    >
      <AttendAllowanceAddForm />
    </SidebarTemplate>
  );
};

export default AttendAllowanceFormAdd;
